import { render, staticRenderFns } from "./PatientProfileEdit.vue?vue&type=template&id=18e4ca6a&scoped=true&"
import script from "./PatientProfileEdit.vue?vue&type=script&lang=ts&"
export * from "./PatientProfileEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e4ca6a",
  null
  
)

export default component.exports